<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 顶部操作栏 -->
      <div style="margin-bottom: 15px">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="handleAdd(null)">新增场室</el-button>
      </div>
      <!-- 场室树形表格 -->
      <el-table :data="tableData" row-key="id" border :tree-props="{ children: 'children' }" default-expand-all
        v-loading="loading">
        <el-table-column prop="roomName" label="场室名称" min-width="200" show-overflow-tooltip>
          <template #default="{ row }">
            <i :class="row.type === 2 ? 'el-icon-box' : 'el-icon-office-building'"
              style="margin-right: 5px; color: #909399"></i>
            {{ row.roomName }}
          </template>
        </el-table-column>
        <el-table-column label="类型" align="center" width="100">
          <template #default="{ row }">
            <el-tag size="mini" :type="row.type === 2 ? 'warning' : 'primary'">
              {{ row.type === 2 ? '仓库' : '场室' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center" width="80" />
        <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip min-width="160" />
        <el-table-column label="操作" align="center" width="240" fixed="right">
          <template #default="{ row }">
            <el-button type="text" size="mini" icon="el-icon-plus" @click="handleAdd(row)">添加子级</el-button>
            <el-button type="text" size="mini" icon="el-icon-edit" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" icon="el-icon-delete" style="color: #f56c6c"
              @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="roomForm" label-width="80px">
        <el-form-item label="场室名称" prop="roomName">
          <el-input v-model="form.roomName" placeholder="请输入场室名称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :label="1">场室</el-radio>
            <el-radio :label="2">仓库</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { roomList, saveRoom, deleteRoom } from '@/config/assetApi';

export default {
  name: 'AssetRoom',
  data () {
    return {
      loading: false,
      tableData: [],
      dialogVisible: false,
      dialogTitle: '新增场室',
      submitLoading: false,
      form: {
        id: null,
        roomName: '',
        parentId: null,
        type: 1,
        sort: 0,
        status: 1,
      },
      rules: {
        roomName: [{ required: true, message: '请输入场室名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
      },
    };
  },
  created () {
    this.fetchList();
  },
  methods: {
    fetchList () {
      this.loading = true;
      roomList()
        .then((res) => {
          if (res.data && res.data.resCode == 200) {
            this.tableData = res.data.data || [];
          } else {
            this.tableData = [];
          }
        })
        .catch(() => {
          this.tableData = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleAdd (parentData) {
      this.dialogTitle = parentData ? `在"${parentData.roomName}"下新增` : '新增场室';
      this.form = {
        id: null,
        roomName: '',
        parentId: parentData ? parentData.id : 0,
        type: 1,
        sort: 0,
        status: 1,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.roomForm && this.$refs.roomForm.clearValidate();
      });
    },
    handleEdit (data) {
      this.dialogTitle = '编辑场室';
      this.form = {
        id: data.id,
        roomName: data.roomName,
        parentId: data.parentId,
        type: data.type,
        sort: data.sort,
        status: data.status,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.roomForm && this.$refs.roomForm.clearValidate();
      });
    },
    handleDelete (data) {
      this.$confirm(`确定要删除场室"${data.roomName}"吗？`, '提示', {
        type: 'warning',
      })
        .then(() => {
          let formData = new FormData();
          formData.append('id', data.id);
          deleteRoom(formData).then((res) => {
            if (res.data && res.data.resCode == 200) {
              this.$message.success('删除成功');
              this.fetchList();
            } else {
              this.$message.error((res.data && res.data.resMsg) || '删除失败');
            }
          });
        })
        .catch(() => { });
    },
    handleSubmit () {
      this.$refs.roomForm.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        let formData = new FormData();
        for (let key in this.form) {
          if (this.form[key] !== null && this.form[key] !== undefined && this.form[key] !== '') {
            formData.append(key, this.form[key]);
          }
        }
        saveRoom(formData)
          .then((res) => {
            if (res.data && res.data.resCode == 200) {
              this.$message.success('保存成功');
              this.dialogVisible = false;
              this.fetchList();
            } else {
              this.$message.error((res.data && res.data.resMsg) || '保存失败');
            }
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped></style>
